import {
  Button,
  Form,
  Input,
  message,
  notification,
  Card,
  Space,
  Switch,
} from "antd";
import { useState, useEffect } from "react";
import axios from "../../../config/axiosInstance";
import { API } from "../../../config/API";
import TextArea from "antd/es/input/TextArea";
import { BsUpload } from "react-icons/bs";
import { MdCancel } from "react-icons/md";
import PageHeader from "../../../component/pageHeaders";
import { POST } from "../../../utils/apirequest";
import { useSelector } from "react-redux";

function NewForm(props: any) {
  const User = useSelector((state: any) => state.User.user);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState<any>("");
  const [isLoading, setIsLoading] = useState<any>(false);
  const [gulfVideoId, setGulfVideoId] = useState() as any;
  const [isPublished, setIsPublished] = useState(false);

  // Populate form if editing
  useEffect(() => {
    if (props.record) {
      const { video_id, description, id, is_published } = props.record;
      form.setFieldsValue({
        video_id,
        description,
      });
      setDescription(description);
      setGulfVideoId(id);
      setIsPublished(is_published || false);
    }
  }, [props.record]);

  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  const onFinish = async (values: any) => {
    try {
      setIsLoading(true);

      let requestData: any = {
        video_id: values.video_id || "",
        description: values.description || description || "",
        is_published: isPublished,
      };

      if (User?.id) {
        requestData.user = User.id;
      }

      let requestObj = {
        data: requestData,
      };

      let res: any;
      if (gulfVideoId) {
        // Update existing
        let url = API.BASE_URL + API.GULF_VIDEO + `/${gulfVideoId}`;
        res = await axios.put(url, requestObj);
      } else {
        // Create new
        let url = API.BASE_URL + API.GULF_VIDEO;
        res = await axios.post(url, requestObj);
      }

      if (res?.data?.id || res?.data?.data?.id) {
        const id = res?.data?.id || res?.data?.data?.id;
        setGulfVideoId(id);
        setIsLoading(false);

        // Always reload data when any save operation succeeds
        props?.reload();

        message.success(
          gulfVideoId ? "Updated successfully" : "Created successfully"
        );
        props?.onClose();
      } else {
        notification.error({
          message: "Something went wrong...!",
          description:
            res?.error?.message || "Please check console for details",
        });
        setIsLoading(false);
      }
    } catch (err: any) {
      console.error("Error details:", err);
      const errorMessage =
        err?.response?.data?.error?.message ||
        err?.message ||
        "Something went wrong...!";
      notification.error({
        message: "Error",
        description: errorMessage,
      });
      setIsLoading(false);
    }
  };

  const onCancel = () => {
    // Clear form
    form.resetFields();
    setDescription("");
    setGulfVideoId(null);
    setIsPublished(false);

    // Go back to listing
    props?.onClose();
  };

  return (
    <>
      <PageHeader
        title={props.record ? "Edit Gulf Video" : "New Gulf Video"}
        onBack={() => props?.onClose()}
      />

      <div
        style={{
          padding: "24px",
          maxWidth: "800px",
          margin: "0 auto",
        }}
      >
        <Card
          style={{
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            border: "1px solid #f0f0f0",
          }}
          bodyStyle={{ padding: "32px" }}
        >
          <Form
            {...formItemLayout}
            onFinish={onFinish}
            form={form}
            layout="vertical"
            requiredMark={false}
            style={{ width: "100%" }}
          >
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
              <Form.Item
                label={
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#262626",
                    }}
                  >
                    Video ID
                  </span>
                }
                name="video_id"
                rules={[{ required: true, message: "Please input video ID!" }]}
              >
                <Input
                  size="large"
                  placeholder="Enter YouTube Video ID (e.g., dQw4w9WgXcQ)"
                  style={{
                    borderRadius: "8px",
                    fontSize: "14px",
                  }}
                />
              </Form.Item>

              <Form.Item
                label={
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#262626",
                    }}
                  >
                    Description
                  </span>
                }
                name="description"
              >
                <TextArea
                  rows={4}
                  placeholder="Enter a detailed description for this video..."
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                  style={{
                    borderRadius: "8px",
                    fontSize: "14px",
                  }}
                />
              </Form.Item>

              <Form.Item
                label={
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#262626",
                    }}
                  >
                    Publish Status
                  </span>
                }
              >
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <Switch
                    checked={isPublished}
                    onChange={(checked) => setIsPublished(checked)}
                    checkedChildren="Published"
                    unCheckedChildren="Draft"
                  />
                  <span style={{ color: "#666", fontSize: 14 }}>
                    {isPublished
                      ? "This video will be visible to users"
                      : "This video will be saved as draft"}
                  </span>
                </div>
              </Form.Item>

              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "flex-end",
                  marginTop: "24px",
                  paddingTop: "24px",
                  borderTop: "1px solid #f0f0f0",
                }}
              >
                <Button
                  size="large"
                  onClick={onCancel}
                  disabled={loading || isLoading}
                  icon={<MdCancel />}
                  style={{
                    borderRadius: "8px",
                    height: "44px",
                    minWidth: "120px",
                  }}
                >
                  Cancel
                </Button>

                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  loading={loading || isLoading}
                  icon={<BsUpload />}
                  style={{
                    borderRadius: "8px",
                    height: "44px",
                    minWidth: "160px",
                    background: "#1890ff",
                    borderColor: "#1890ff",
                  }}
                >
                  {gulfVideoId ? "Update" : "Save"}
                </Button>
              </div>
            </Space>
          </Form>
        </Card>
      </div>
    </>
  );
}

export default NewForm;
